/**
 * form Analytics/Tracking API services
 *
 */

export const fireAnalyticsEvent = event => {
  try {
    const $dataLayer = document.getElementById('vw-data-layer')
    const customEvent = new CustomEvent('data-layer-event-fired', {
      detail: event
    })
    window.dataLayer.event.push(event)
    $dataLayer.dispatchEvent(customEvent)
    console.log('push: fireAnalyticsEvent', event)
  } catch (error) {
    console.warn('error analytics vw-data-layer', error)
  }
}

export const firePageIsLoading = vehicleId => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'pageLoaded',
    eventName: 'form page load',
    vehicleId
  })
}

export const fireCtaIsClicked = (label, url, target) => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'ctaClick',
    eventName: 'cta on success page clicked',
    label,
    url,
    target
  })
}

export const fireSubmitError = (
  errors,
  label,
  vehicleId,
  vehicleLabel,
  customerType,
  marketingConsent
) => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'submitError',
    eventName: 'form contains errors',
    errors,
    label,
    vehicleId,
    vehicleLabel,
    customerType,
    marketingConsent
  })
}
export const fireSubmitIsClicked = (
  label,
  vehicleId,
  vehicleLabel,
  customerType,
  marketingConsent,
  enquiryType
) => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'submitClicked',
    eventName: 'form submit is clicked',
    label,
    vehicleId,
    vehicleLabel,
    customerType,
    marketingConsent,
    enquiryType
  })
}
export const fireSubmitIsASucess = (
  vehicleId,
  vehicleLabel,
  customerType,
  marketingConsent,
  enquiryType
) => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'submitSuccess',
    eventName: 'form submit is sucessfully been sent',
    vehicleId,
    vehicleLabel,
    customerType,
    marketingConsent,
    enquiryType
  })
}
export const fireSubmitFailed = (error, vehicleId, vehicleLabel) => {
  fireAnalyticsEvent({
    location: 'form',
    eventAction: 'submitFailed',
    eventName: 'form submit failed to sent',
    error,
    vehicleId,
    vehicleLabel
  })
}
